import type { PollingLogEntry } from "@shared/api/generated/model";
import { Popover, Tag, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";

export const pollingLogColumns: ColumnsType<PollingLogEntry> = [
  {
    title: "Дата",
    dataIndex: "event_time",
    width: 140,
    render: (value?: string) => (value ? dayjs(value).format("DD.MM.YYYY HH:mm:ss") : "—"),
  },
  {
    title: "Счётчик",
    dataIndex: "meter_id",
    width: 120,
    render: (_value, row) => (
      <span style={{ fontFamily: "monospace" }}>{row.meter_serial || row.meter_id || "—"}</span>
    ),
  },
  {
    title: "Объект",
    dataIndex: "object_name",
    width: 180,
    ellipsis: true,
    render: (_value, row) => (row.object_name ? `${row.object_name}` : "—"),
  },
  {
    title: "Код",
    dataIndex: "event_code",
    width: 60,
    render: (value: number) => (
      <Tag color="blue" style={{ fontFamily: "monospace" }}>
        {value}
      </Tag>
    ),
  },
  {
    title: "Сообщение",
    dataIndex: "event_text",
    width: 280,
    ellipsis: true,
    render: (value?: string) => value || "—",
  },
  {
    title: "Системные ошибки",
    dataIndex: "sys_error_text",
    width: 200,
    render: (value?: string[]) => {
      if (!value || value.length === 0) return "—";

      const content = (
        <div style={{ maxWidth: 400 }}>
          {value.map((err) => (
            <Typography.Paragraph key={err} style={{ margin: 0 }}>
              {err}
            </Typography.Paragraph>
          ))}
        </div>
      );

      if (value.length === 1) {
        return <Tag color="red">{value[0]}</Tag>;
      }

      return (
        <Popover content={content} title="Системные ошибки">
          <Tag color="red" style={{ cursor: "pointer" }}>
            {value.length} ошибок
          </Tag>
        </Popover>
      );
    },
  },
];
